import { alpha, Tooltip } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { GridIcon } from 'features/dial-pad/components';
import { DialPadButtonBase } from 'features/dial-pad/styles';
import {
  selectIsDialPadCollapsed,
  toggleDialPadCollapse,
} from 'features/dial-pad/store';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export const DialPadCollapseButton: FC = () => {
  const { t } = useTranslation('translation');
  const dispatch = useAppDispatch();
  const isCollapsed = useAppSelector(selectIsDialPadCollapsed);

  const handleToggleCollapse = () => {
    dispatch(toggleDialPadCollapse());
  };

  return (
    <Tooltip
      title={isCollapsed ? t('dialPad.showButtons') : t('dialPad.hideButtons')}
      arrow
    >
      <CollapseButton
        onClick={handleToggleCollapse}
        data-testid='dialpad-collapse-button'
      >
        <IconWrapper $isCollapsed={isCollapsed}>
          <GridIcon />
          {isCollapsed && <StrikeThroughLine />}
        </IconWrapper>
      </CollapseButton>
    </Tooltip>
  );
};

const CollapseButton = styled(DialPadButtonBase)`
  flex: 0.5;
  border: 1px solid ${alpha(theme.palette.common.white, 0.1)};
  position: relative;
`;

const IconWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== '$isCollapsed',
})<{ $isCollapsed?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 24px;
  height: 24px;
`;

const StrikeThroughLine = styled('div')`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background-color: ${theme.palette.common.white};
  transform: rotate(-45deg);
  pointer-events: none;
`;
